/* v8 ignore start */
import {ArrayUtils} from "@/lib/utils/arrayUtils";

export namespace StringUtils {
  export interface IStringifyable {
    toString(): string;
  }

  export function isString(value: any): value is string {
    return typeof value === "string";
  }

  export function pluralize(count: number, singular: string, options?: IPluralizeOptions): string {
    const opt = {...defaultPluralizeOptions, ...options};
    const prefix = opt.prefix === undefined ? count : opt.prefix;
    const suffix = count === 1 ? singular : opt.plural || singular + opt.suffix!;

    return `${prefix} ${suffix}`;
  }

  export function capitalize(value: string): string {
    return value.charAt(0).toUpperCase() + value.substr(1);
  }

  export function toCamelCase(value: string): string {
    return value.replace(/(^[A-Z])|[_-\s]([A-Za-z0-9])/g, (m, a, b) => (a ? a.toLowerCase() : b.toUpperCase()));
  }

  export function toKebabCase(value: string): string {
    return value
      .replace(/_|(^([A-Z]|[0-9])+)|(\s*([A-Z]|[0-9])+)/g, (m, a, b, c) =>
        a ? a.toLowerCase() : "-" + (c ? c.trim().toLowerCase() : "")
      )
      .replace(/-{2,}/g, "-");
  }

  export function fromCamelCase(value: string): string {
    return value.replace(/([A-Z0-9]+)/g, " $1").toLowerCase();
  }

  export function toPascalCase(value: string): string {
    return value
      .replace(/[\W_]+/g, " ")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join("");
  }

  export function repeat(value: string, count: number): string {
    return Array(count + 1).join(value);
  }

  export function leftPad(value: IStringifyable, fixedLength: number, charString: string): string {
    const baseString = value.toString();
    const charsToPad = fixedLength - baseString.length;

    if (charsToPad > 0) {
      const char = charString[0] || " ";

      return ArrayUtils.create(charsToPad).reduce((string) => char + string, baseString);
    } else {
      return baseString;
    }
  }

  export function isEqual(a?: string, b?: string): boolean {
    return a?.toLowerCase() === b?.toLowerCase();
  }

  export function compare(a?: string, b?: string): number {
    if (!a && !b) {
      return 0;
    }

    if (!a) {
      return -1;
    }

    if (!b) {
      return 1;
    }

    if (a < b) {
      return -1;
    }

    if (a > b) {
      return 1;
    }

    return 0;
  }

  export function slug(value: string): string {
    return value
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  export function possessive(value: string): string {
    const lastChar = value.slice(-1).toLowerCase();

    if (lastChar === "s") {
      return `${value}'`;
    }

    return `${value}'s`;
  }
}

interface IPluralizeOptions {
  plural?: string;
  suffix?: string;
  prefix?: string;
}

const defaultPluralizeOptions: IPluralizeOptions = {
  suffix: "s",
};
/* v8 ignore stop */
